import React from 'react';
import loadable from "@loadable/component";
import {Route} from 'react-router-dom';


const HesiDashboard = loadable(() => import("./HesiDashboard.js"))
const HesiAssessmentDashboard = loadable(() => import("./HesiAssessmentDashboard.js"))
const HesiReviewDashboard = loadable(() => import("./HesiReviewDashboard.js"))

export default [
    <Route exact path="/admin/hesi/" element={<HesiDashboard/>} />,
    <Route exact path="/admin/hesi/:assessmentID/assessment/" element={<HesiAssessmentDashboard/>} />,
    <Route exact path="/admin/hesi/:assessmentID/review/" element={<HesiReviewDashboard/>} />,
]